import { phoneValidate } from "../util/phoneValidate";

$(function() {
    let $userDetailsForm = $('#userDetailsForm');
    let email = false;
    let telephone = false;
    let terms = false;

    const form = {
        enabledSubmit: function () {
            $userDetailsForm.find('button[type="submit"]').removeAttr('disabled');
            $userDetailsForm.find('button[type="submit"]').removeClass('disabled');
            $userDetailsForm.find('button[type="submit"]').addClass('accent_red');
        },
        disabledSubmit: function () {
            $userDetailsForm.find('button[type="submit"]').attr('disabled', true);
            $userDetailsForm.find('button[type="submit"]').addClass('disabled');
        },
    };

    $userDetailsForm.find('input[name="email"]').on('keyup', function () {
        if($(this).val() !== '') {
            email = true;
        } else {
            email = false;
        }
        if(email === true && telephone === true && terms === true) {
            form.enabledSubmit();
        } else {
            form.disabledSubmit();
        }
    });

    $userDetailsForm.find('input[name="full_name"]').keypress(function(event) {
        return /[а-яА-ЯёЁa-zA-Z /s]/i.test(event.key);
    });

    $userDetailsForm.find('input[name="telephone"]').keypress(function(event) {
        return /\d/.test(String.fromCharCode(event.keyCode));
    });

    $userDetailsForm.find('input[name="telephone"]').on('keyup', function () {
        if($(this).val() !== '') {
            telephone = true;
        } else {
            telephone = false;
        }

        if($(this).val().length <= 15 && $(this).val().length > 0) {
            telephone = true;
        } else {
            telephone = false;
        }

        if(email === true && telephone === true && terms === true) {
            form.enabledSubmit();
        } else {
            form.disabledSubmit();
        }
    });

    $userDetailsForm.find('input[name="telephone"]').focus(function () {
        $(this).removeClass('is-invalid');
    });

    $userDetailsForm.find('.form-check').on('click', function () {
        if($(this).children('input[name="accepted_terms"]').is(':checked')) {
            terms = true;
        } else {
            terms = false;
        }
        if(email === true && telephone === true && terms === true) {
            form.enabledSubmit();
        } else {
            form.disabledSubmit();
        }
    });
    
    if($userDetailsForm.find('input[name="accepted_terms"]').is(':checked')) {
        terms = true;
        if(email === true && telephone === true && terms === true) {
            form.enabledSubmit();
        } else {
            form.disabledSubmit();
        }
    }

    let forms = $('.user-details');
    Array.prototype.filter.call(forms, function(form) {
        $(form).on('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let $this = $(this);
            let $button = $(this).find('button[type="submit"]');
            if(form.checkValidity() !== false) {
                $button.addClass('disabled');
                $button.attr('disabled', true);
                let formData = $this.serializeArray();
                if(phoneValidate($this.find('input[name="telephone"]'))) {
                    saveUserDetailsForm(formData);
                }
            }
        });
    });

    function saveUserDetailsForm(formData) {
        $.ajax({
            url: window.ajax_url,
            data: {
                'action': 'user_details_form',
                'data': formData,
            },
            type: 'POST',
        }).done(function (res) {
            let response = JSON.parse(res);
            if(Object.keys(response.quiz).length !== 0 && Object.keys(response.form).length !== 0) {
                $('#userDetailsFormModal').modal('hide');
                localStorage.setItem('preloader', 'false');
            }
        }).fail(function (error) {
            alert(error);
        });
    }
});


// WEBPACK FOOTER //
// ./scripts/routes/user-details-form.js